(() => {
  const ready = () => {
    document.querySelectorAll('[data-culm-menu-toggle]').forEach((button) => {
      const target = document.querySelector(button.getAttribute('aria-controls') ? `#${button.getAttribute('aria-controls')}` : '');
      if (!target) return;
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!open));
        target.classList.toggle('is-open', !open);
      });
    });

    document.querySelectorAll('[data-culm-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[data-culm-form-status]');
        if (!button) return;
        button.disabled = true;
        if (status) status.textContent = '';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Accept': 'application/json' },
            body: new FormData(form)
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this piece.');
          if (status) status.textContent = 'Added to bag.';
          const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((r) => r.json());
          document.querySelectorAll('[data-culm-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
        } catch (error) {
          if (status) status.textContent = error.message;
        } finally {
          button.disabled = false;
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
})();
